<template>
    <v-card class="grey lighten-3">
        <v-container fluid grid-list-xs>
            <v-layout row>
                <v-flex xs6>
                    <div class="text-xs-left">
                        <span class="cyan--text text--darken-4 subtitle-1 font-weight-bold">
                            <v-icon color="cyan darken-3">mdi-clipboard-pulse-outline</v-icon>&nbsp; Consulta: 2020-04-21 - Edad: 4 años 5 meses
                        </span>
                    </div>
                </v-flex>
                <v-flex xs6 class="text-xs-center text-end">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled="bEdit" icon @click="onEdit" v-on="on">
                                <v-icon color="orange darken-2">mdi-square-edit-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Editar consulta</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled="!bEdit" icon @click="onSave" v-on="on">
                                <v-icon color="orange darken-2">mdi-clipboard-check-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Guardar consulta</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled="!bEdit" icon @click="onCancel" v-on="on">
                                <v-icon color="orange darken-2">mdi-pencil-off</v-icon>
                            </v-btn>
                        </template>
                        <span>Cancelar edición</span>
                    </v-tooltip>

                    <v-divider class="mx-2" inset vertical></v-divider>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled="bEdit" icon @click="onDelete" v-on="on">
                                <v-icon color="orange darken-2">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Borrar consulta</span>
                    </v-tooltip>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12>
                    <v-card flat class="grey lighten-3">
                        <v-container pa-0 fluid>
                            <v-layout row>
                                <v-flex xs12>
                                    <v-tabs background-color="cyan darken-2" dark show-arrows>
                                        <v-tab class="text-none">Consulta</v-tab>
                                        <v-tab class="text-none">Recetas</v-tab>
                                        <v-tab class="text-none">CIE10</v-tab>

                                        <!--****************************** Tab Consulta: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat class="grey lighten-4">
                                                <v-card-text>
                                                    <v-container fluid grid-list-xs>
                                                        <v-layout row justify-space-between>
                                                            <v-flex xs3>
                                                                <v-container fluid>
                                                                    <v-layout row>
                                                                        <v-flex xs12>
                                                                            <v-textarea
                                                                                dense
                                                                                outlined
                                                                                :auto-grow="false"
                                                                                no-resize
                                                                                color="cyan darken-2"
                                                                                label="Subjetivo"
                                                                                :rows="soapRows"
                                                                            ></v-textarea>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row>
                                                                        <v-flex xs12>
                                                                            <v-textarea
                                                                                dense
                                                                                outlined
                                                                                :auto-grow="false"
                                                                                no-resize
                                                                                color="cyan darken-2"
                                                                                label="Objetivo"
                                                                                :rows="soapRows"
                                                                            ></v-textarea>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-container>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <v-container fluid grid-list-xs>
                                                                    <v-layout row>
                                                                        <v-flex xs12>
                                                                            <div
                                                                                class="text-xs-left"
                                                                            >
                                                                                <span
                                                                                    class="teal--text text--darken-3 body-2"
                                                                                >Somatometría</span>
                                                                            </div>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-divider
                                                                        class="cyan darken-2"
                                                                    ></v-divider>
                                                                    <v-layout
                                                                        row
                                                                        justify-space-between
                                                                    >
                                                                        <v-flex xs5>
                                                                            <v-text-field
                                                                                label="Peso"
                                                                                hint="kg"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-weight"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs5>
                                                                            <v-text-field
                                                                                label="Pulso"
                                                                                hint="lpm"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-heart-pulse"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout
                                                                        row
                                                                        justify-space-between
                                                                    >
                                                                        <v-flex xs5>
                                                                            <v-text-field
                                                                                label="Talla"
                                                                                hint="m"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-human-male-height"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs5>
                                                                            <v-text-field
                                                                                label="Respiración"
                                                                                hint="rpm"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-lungs"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout
                                                                        row
                                                                        justify-space-between
                                                                    >
                                                                        <v-flex xs5>
                                                                            <v-text-field
                                                                                label="IMC"
                                                                                hint="kg/m2"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-human"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs6>
                                                                            <v-text-field
                                                                                label="Temperatura"
                                                                                hint="°C"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-thermometer"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout
                                                                        row
                                                                        justify-space-between
                                                                    >
                                                                        <v-flex xs7>
                                                                            <v-text-field
                                                                                label="Perímetro Cefálico"
                                                                                hint="cm"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-head"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs5>
                                                                            <v-text-field
                                                                                label="Glucosa"
                                                                                hint="mg/dL"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-cube-outline"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout
                                                                        row
                                                                        justify-space-between
                                                                    >
                                                                        <v-flex xs7>
                                                                            <v-text-field
                                                                                label="Tensión Arterial"
                                                                                hint="mm Hg"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-heart-multiple"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>

                                                                        <v-flex xs5>
                                                                            <v-text-field
                                                                                label="SpO2"
                                                                                hint="%"
                                                                                persistent-hint
                                                                                prepend-inner-icon="mdi-water-percent"
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-container>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <v-container fluid>
                                                                    <v-layout row>
                                                                        <v-flex xs6>
                                                                            <v-textarea
                                                                                dense
                                                                                outlined
                                                                                :auto-grow="false"
                                                                                no-resize
                                                                                color="cyan darken-2"
                                                                                label="Análisis"
                                                                                :rows="soapRows"
                                                                            ></v-textarea>
                                                                        </v-flex>
                                                                        <v-flex xs6>
                                                                            <v-textarea
                                                                                dense
                                                                                outlined
                                                                                :auto-grow="false"
                                                                                no-resize
                                                                                color="cyan darken-2"
                                                                                label="Plan"
                                                                                :rows="soapRows"
                                                                            ></v-textarea>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row>
                                                                        <v-flex xs12>
                                                                            <v-textarea
                                                                                dense
                                                                                outlined
                                                                                :auto-grow="false"
                                                                                no-resize
                                                                                color="red"
                                                                                label="Información Importante"
                                                                                :rows="soapRows / 3"
                                                                            ></v-textarea>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row>
                                                                        <v-flex xs12>
                                                                            <v-text-field
                                                                                label="Paciente atendido por:"
                                                                                prefix="Dr."
                                                                                persistent-hint
                                                                                color="cyan darken-2"
                                                                                dense
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-container>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--****************************** Tab Identificación: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-container fluid grid-list-xs>
                                                        <v-layout row>
                                                            <v-flex xs12></v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--****************************** Tab Información Complementaria: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-container fluid>
                                                        <v-layout row>
                                                            <v-flex xs12></v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--****************************** Tab Contacto: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-container fluid>
                                                        <v-layout row>
                                                            <v-flex xs12></v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--****************************** Tab Responsable: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-container fluid>
                                                        <v-layout row>
                                                            <v-flex xs12></v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                    </v-tabs>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Consult',
    data() {
        return {
            soapRows: 9
        };
    },
    props: {
        patient: Object
    },
    components: {},
    created() {},
    methods: {
        onEdit() {
            this.bEdit = true;
        },
        onCancel() {
            this.bEdit = false;
        },
        onSave() {
            this.bEdit = false;
        },
        onDelete() {}
    },
    computed: {
        ...mapGetters(['waitCursor'])
    }
};
</script>

<style scoped>
.gmp-green {
    color: #0097a7;
}
</style>